/* eslint-disable @nx/enforce-module-boundaries */
import { Modal, ModalContent, ModalOverlay } from '@mybridge/ui/modal';
import { useState } from 'react';
import { DashboardReelContainer } from '../reel-container';
import { useRouter } from 'next/router';
import { Text } from '@mybridge/ui';

import { isMobile } from 'react-device-detect';

export const DashboardReelModal = ({ page,reelId, ...props }) => {
  const [expanded, setExpanded] = useState(false);
  const { back } = useRouter();
  return (
    <Modal
      size={isMobile || expanded ? 'full' : '2xl'}
      {...props}
      motionPreset="slideInBottom"
      closeOnOverlayClick={true}
      scrollBehavior="inside"
    >
      <ModalOverlay />
      <ModalContent
        borderRadius={isMobile || expanded ? 0 : 10}
        overflow="hidden"
        border="none"
        marginTop={isMobile ? 0 : (!expanded ? `40px` : '0')}
        minW={isMobile ? '100vw' : '750px'}
        maxW={isMobile ? '100vw' : undefined}
      >
        <DashboardReelContainer
          onClose={(e) => {
            // back?.();
            props?.onClose?.(e);
          }}
          page={page}
          reelId={reelId}
          setHasMedia={(m) => {
            setExpanded(m);
          }}
        />
      </ModalContent>
    </Modal>
  );
};
